import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i1538167568__Layer_1",
  viewBox: "0 0 333.71 281.72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0v281.72h333.71V0H0Zm8.09 59.85h59.6v43.87H8.09V59.85Zm317.53 213.78h-69.25V262.4h-7.33v5.04l-4.43 3.51H232.4l-4.43-3.51v-5.04h-7.33v11.23h-69.25V244.5h-8.09v29.13H8.09v-118.2h7.88v-4.05H8.09v-39.57h98.07v39.57H41.77v4.05h68.43v-43.62h3.7v-8.09h-9.12v-20.8c2.01-.25 3.58-1.96 3.58-4.04V38.1c0-2.25-1.83-4.09-4.09-4.09-2.07 0-3.77 1.55-4.03 3.56H75.78v-1.71h-8.09v15.89H8.09V8.09h59.6v1.97h8.09V8.09h67.53V38.6h8.09V8.09h94.08v11.22h7.33v-5.04l4.43-3.51h12.21l4.43 3.51v5.04h7.33V8.09h44.41v265.54ZM75.79 38.59h24.41v3.74H75.79v-3.74Zm15.48 65.14 11.43-21.07c.34.14.7.22 1.07.27v20.8h-12.5Zm8.99-24.15c.02.1.04.19.06.28l-24.54 11.3v-6.97l24.48-4.61Zm1.57 2.56-11.71 21.59H76.44l24.9-22.01c.15.16.32.29.49.42Zm2.45-.18c-1.7 0-3.08-1.38-3.08-3.08V38.1c0-1.7 1.38-3.08 3.08-3.08s3.08 1.38 3.08 3.08v40.78c0 1.7-1.38 3.08-3.08 3.08Zm-28.49 20.99V92.27L100.7 80.8s.03.06.05.09l-24.96 22.06Zm0-59.61h24.41v3.74H75.79v-3.74Zm0 4.75h24.41v3.74H75.79v-3.74Zm0 4.75h24.41v3.74H75.79v-3.74Zm0 4.75h24.41v3.74H75.79v-3.74Zm0 4.75h24.41v3.74H75.79v-3.74Zm0 4.75h24.41v3.74H75.79v-3.74Zm0 4.75h24.41v3.76l-24.41 1.29v-5.06Zm0 6.07 24.41-1.29v1.94l-24.41 4.6v-5.24ZM332.7 247.43h-6.07v-34.4h6.07v34.4Zm0-89.34h-6.07v-34.4h6.07v34.4Zm0-89.28h-6.07v-34.4h6.07v34.4Z",
  class: "i1538167568__cls-1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M143.31 103.72h-3.6v8.09h3.6v98.29h8.09V73h-8.09v30.72z",
  class: "i1538167568__cls-1"
}, null, -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [
          _createTextVNode(".i1538167568__cls-1{stroke-width:0}")
        ]),
        _: 1
      }))
    ]),
    _hoisted_2,
    _hoisted_3
  ]))
}
export default { render: render }